import { Button, Drawer, Space } from "antd";
import Menu from "./Menu";
import { MenuUnfoldOutlined } from "@ant-design/icons";
import { AppRoute } from "./routes";

const MobileMenuDrawer = ({
  open,
  setOpen,
  routes,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  routes: AppRoute[];
}) => {


  const onClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
     title={
        <img
          src={"/logo.png"}
          alt="Logo"
          className="w-24 h-10 object-contain"
        />
      }
      placement={"left"}
      closable={false}
      onClose={onClose}
      className=" block sm:hidden "
      width={250}
      open={open}
      key={"left"}
      extra={
        <Space>
          <Button
            type="text"
            className="rounded-full bg-white/60 hover:bg-primary"
            onClick={onClose}
            icon={
              <MenuUnfoldOutlined className=" !text-[13px] sm:!text-[15px]" />
            }
          />
        </Space>
      }
    >
      <Menu onClose={onClose} routes={routes} />
    </Drawer>
  );
};

export default MobileMenuDrawer;
